/* Lumelyy theme JS — cart drawer (native Cart AJAX API + Section Rendering),
   quantity steppers, accordions, countdowns, bundle picker, promo display. */
(function () {
  'use strict';

  var config = window.LumelyyConfig || {};

  function formatMoney(cents) {
    var format = config.moneyFormat || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    var withThousands = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return format
      .replace(/\{\{\s*amount\s*\}\}/, withThousands)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','));
  }

  /* ---------- Cart drawer ---------- */

  function drawerEl() { return document.getElementById('LumCartDrawer'); }

  function headerSectionId() {
    var el = drawerEl();
    return el ? el.getAttribute('data-section-id') : null;
  }

  function openDrawer() {
    var el = drawerEl();
    if (!el) return;
    el.hidden = false;
    document.body.style.overflow = 'hidden';
    var close = el.querySelector('.lum-drawer__close');
    if (close) close.focus({ preventScroll: true });
  }

  function closeDrawer() {
    var el = drawerEl();
    if (!el) return;
    el.hidden = true;
    document.body.style.overflow = '';
  }

  /* Show "code saved" notes wherever [data-lum-applied-code] exists,
     based on Shopify's discount_code cookie (set by /discount/CODE). */
  function clearDiscountCookie() {
    document.cookie = 'discount_code=; max-age=0; path=/';
  }

  /* Re-render the cart-facing sections so server-side discount math shows. */
  function refreshCartSections() {
    fetch((config.routes && config.routes.cart || '/cart') + '/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: {}, sections: sectionIdsToRender(), sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); })
      .then(function (d) { applySections(d.sections); })
      .catch(function () {});
  }

  function updateAppliedCode() {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
    var code = m ? decodeURIComponent(m[1]).toUpperCase() : '';

    /* Only manage codes this store actually issues. */
    if (code && knownCodes().indexOf(code) === -1) code = '';

    if (!code) return;

    /* Bundle codes only survive while EVERY bundle item is in the bag.
       (All visible discount math renders server-side from the cart itself.) */
    var bundles = config.bundleCodes || {};
    if (bundles[code]) {
      var lines = document.querySelectorAll('#LumCartDrawer [data-lum-line]');
      if (lines.length) {
        var present = {};
        lines.forEach(function (line) { present[line.getAttribute('data-variant-id')] = true; });
        var complete = bundles[code].every(function (vid) { return present[String(vid)]; });
        if (!complete) {
          clearDiscountCookie();
          refreshCartSections();
        }
      }
    }
  }

  /* Re-render Shopify sections (header incl. drawer, cart page) from
     a Cart AJAX response that carried a `sections` payload. */
  function applySections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var current = document.getElementById('shopify-section-' + id);
      if (!current || !sections[id]) return;
      var wasOpen = false;
      var drawer = current.querySelector('#LumCartDrawer');
      if (drawer && !drawer.hidden) wasOpen = true;
      var holder = document.createElement('div');
      holder.innerHTML = sections[id];
      var fresh = holder.firstElementChild;
      if (fresh) {
        current.replaceWith(fresh);
        if (wasOpen) {
          var freshDrawer = fresh.querySelector('#LumCartDrawer');
          if (freshDrawer) freshDrawer.hidden = false;
        }
      }
    });
    updateAppliedCode();
  }

  function sectionIdsToRender() {
    var ids = [];
    var hid = headerSectionId();
    if (hid) ids.push(hid);
    var cartSection = document.querySelector('[data-lum-cart-section]');
    if (cartSection) ids.push(cartSection.getAttribute('data-lum-cart-section'));
    return ids;
  }

  function cartRequest(url, payload) {
    payload.sections = sectionIdsToRender();
    payload.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw data;
        applySections(data.sections);
        return data;
      });
    });
  }

  function addToCart(items, opts) {
    return cartRequest(config.routes && config.routes.cartAdd || '/cart/add.js', { items: items })
      .then(function (data) {
        if (!opts || opts.open !== false) openDrawer();
        return data;
      })
      .catch(function (err) {
        var msg = (err && (err.description || err.message)) || 'Something went wrong — please try again.';
        window.alert(msg);
      });
  }

  function changeLine(lineKey, quantity) {
    return cartRequest(config.routes && config.routes.cartChange || '/cart/change.js', {
      id: lineKey,
      quantity: quantity
    }).catch(function () { /* keep current UI on failure */ });
  }

  /* ---------- Delegated clicks ---------- */

  document.addEventListener('click', function (e) {
    var t;

    if (e.target.closest('[data-lum-open-drawer]')) {
      e.preventDefault();
      openDrawer();
      return;
    }
    if (e.target.closest('[data-lum-close-drawer]')) {
      e.preventDefault();
      closeDrawer();
      return;
    }

    t = e.target.closest('[data-lum-line-qty]');
    if (t) {
      e.preventDefault();
      changeLine(t.getAttribute('data-line-key'), parseInt(t.getAttribute('data-lum-line-qty'), 10));
      return;
    }

    /* Pre-checkout upsell interstitial */
    t = e.target.closest('.lum-drawer__checkout, .lum-cart__checkout');
    if (t) {
      var pcModal = document.getElementById('LumPreCheckout');
      if (!pcModal && t.classList.contains('lum-cart__checkout')) {
        pcModal = document.getElementById('LumPreCheckoutDuo');
      }
      if (pcModal) {
        e.preventDefault();
        var pcDrawer = document.getElementById('LumCartDrawer');
        window.__lumPcDrawerWasOpen = !!(pcDrawer && !pcDrawer.hidden);
        if (window.__lumPcReset) window.__lumPcReset(pcModal);
        pcModal.hidden = false;
      }
      return;
    }

    t = e.target.closest('[data-lum-precheck-add]');
    if (t) {
      e.preventDefault();
      var pcm = document.getElementById('LumPreCheckout');
      if (!pcm) return;
      var pcVid = parseInt(pcm.getAttribute('data-variant'), 10);
      var pcCode = pcm.getAttribute('data-code');
      pcm.hidden = true;
      var pcPrimed = pcCode
        ? fetch('/discount/' + encodeURIComponent(pcCode)).catch(function () {})
        : Promise.resolve();
      pcPrimed.then(function () {
        addToCart([{ id: pcVid, quantity: 1 }], { open: !!window.__lumPcDrawerWasOpen });
      });
      return;
    }

    t = e.target.closest('[data-lum-precheck-duo-add]');
    if (t) {
      e.preventDefault();
      var dm = document.getElementById('LumPreCheckoutDuo');
      if (!dm) return;
      var dvs = dm.getAttribute('data-variants').split(',').map(function (sv) {
        return { id: parseInt(sv, 10), quantity: 1 };
      });
      var dcs = [];
      var dKeep = dm.getAttribute('data-keep-code');
      var dNew = dm.getAttribute('data-code');
      if (dKeep) dcs.push(dKeep);
      if (dNew) dcs.push(dNew);
      dm.hidden = true;
      var dPrimed = dcs.length
        ? fetch('/discount/' + dcs.map(encodeURIComponent).join(',')).catch(function () {})
        : Promise.resolve();
      dPrimed.then(function () { addToCart(dvs, { open: false }); });
      return;
    }

    t = e.target.closest('[data-lum-precheck-skip]');
    if (t) {
      e.preventDefault();
      window.location.href = '/checkout';
      return;
    }

    t = e.target.closest('[data-lum-precheck-close]');
    if (t) {
      e.preventDefault();
      var pcc = t.closest('.lum-precheck');
      if (pcc) pcc.hidden = true;
      return;
    }

    t = e.target.closest('[data-lum-bundle-remove]');
    if (t) {
      e.preventDefault();
      var rmUpd = {};
      t.getAttribute('data-lum-bundle-remove').split(',').forEach(function (k) { rmUpd[k] = 0; });
      cartRequest('/cart/update.js', { updates: rmUpd }).catch(function () {});
      return;
    }

    t = e.target.closest('[data-lum-line-remove]');
    if (t) {
      e.preventDefault();
      changeLine(t.getAttribute('data-lum-line-remove'), 0);
      return;
    }

    t = e.target.closest('[data-lum-add-variant]');
    if (t) {
      e.preventDefault();
      var addItems = [{ id: parseInt(t.getAttribute('data-lum-add-variant'), 10), quantity: 1 }];
      var addOpts = { open: t.hasAttribute('data-lum-add-open') };
      /* Bundle-completing upsell: prime its code first so the discount is
         already applied in the re-rendered cart. */
      var addCode = t.getAttribute('data-lum-add-code');
      var addPrimed = addCode
        ? fetch('/discount/' + encodeURIComponent(addCode)).catch(function () {})
        : Promise.resolve();
      addPrimed.then(function () { addToCart(addItems, addOpts); });
      return;
    }

    /* Bundle duo: prime the bundle code FIRST, then add both items so the
       re-rendered cart already shows the discount applied. */
    t = e.target.closest('[data-lum-bundle-add]');
    if (t) {
      e.preventDefault();
      var code = t.getAttribute('data-code');
      var items = t.getAttribute('data-variants').split(',').map(function (s) {
        return { id: parseInt(s, 10), quantity: 1 };
      });
      var primed = code
        ? fetch('/discount/' + encodeURIComponent(code)).catch(function () {})
        : Promise.resolve();
      primed.then(function () { addToCart(items); });
      return;
    }

    /* Accordion — one open at a time */
    t = e.target.closest('.lum-acc__q');
    if (t) {
      var item = t.closest('.lum-acc__item');
      var list = t.closest('[data-lum-accordion]');
      if (item && list) {
        var wasOpen = item.hasAttribute('data-open');
        list.querySelectorAll('.lum-acc__item[data-open]').forEach(function (other) {
          other.removeAttribute('data-open');
          var m = other.querySelector('.lum-acc__mark');
          if (m) m.textContent = '+';
          var q = other.querySelector('.lum-acc__q');
          if (q) q.setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) {
          item.setAttribute('data-open', '');
          var mark = item.querySelector('.lum-acc__mark');
          if (mark) mark.textContent = '−';
          t.setAttribute('aria-expanded', 'true');
        }
      }
      return;
    }

    /* Bundle picker */
    t = e.target.closest('.lum-bundle');
    if (t) {
      var picker = t.closest('[data-lum-bundles]');
      if (picker) {
        picker.querySelectorAll('.lum-bundle').forEach(function (b) { b.setAttribute('aria-checked', 'false'); });
        t.setAttribute('aria-checked', 'true');
        updateBuybox(t.closest('[data-lum-product]'));
      }
      return;
    }

    /* Product qty stepper (pre-add-to-cart) */
    t = e.target.closest('[data-lum-qty-step]');
    if (t) {
      e.preventDefault();
      var box = t.closest('[data-lum-product]');
      var span = t.parentElement.querySelector('[data-lum-qty-value]');
      var qty = parseInt(span.textContent, 10) || 1;
      qty = Math.min(9, Math.max(1, qty + parseInt(t.getAttribute('data-lum-qty-step'), 10)));
      span.textContent = qty;
      var input = box && box.querySelector('input[name="quantity"]');
      if (input) input.value = qty;
      updateBuybox(box);
      return;
    }

    /* PDP gallery thumbs */
    t = e.target.closest('[data-lum-thumb]');
    if (t) {
      e.preventDefault();
      var gallery = t.closest('.lum-pdp__gallery');
      var main = gallery && gallery.querySelector('.lum-pdp__main img');
      var src = t.getAttribute('data-lum-thumb');
      if (main && src) {
        main.src = src;
        if (t.hasAttribute('data-lum-thumb-srcset')) main.srcset = t.getAttribute('data-lum-thumb-srcset');
        else main.removeAttribute('srcset');
      }
      gallery.querySelectorAll('.lum-pdp__thumb').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
      t.setAttribute('aria-current', 'true');
      return;
    }

    /* Promo code apply (display only — discount actually applies at checkout) */
    t = e.target.closest('[data-lum-promo-apply]');
    if (t) {
      e.preventDefault();
      applyPromo(t.closest('[data-lum-promo]'));
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* ---------- Product form (add to cart -> drawer) ---------- */

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-lum-atc-form]');
    if (!form) return;
    e.preventDefault();
    var variantId = parseInt(form.querySelector('input[name="id"]').value, 10);
    var qtyInput = form.querySelector('input[name="quantity"]');
    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    var btn = form.querySelector('button[type="submit"]');
    if (btn) btn.disabled = true;
    addToCart([{ id: variantId, quantity: qty }]).then(function () {
      if (btn) btn.disabled = false;
    });
  });

  /* ---------- Buybox price sync (bundle picker + qty) ---------- */

  function updateBuybox(box) {
    if (!box) return;
    var checked = box.querySelector('.lum-bundle[aria-checked="true"]');
    if (!checked) return;
    var price = parseInt(checked.getAttribute('data-price'), 10);
    var compare = parseInt(checked.getAttribute('data-compare'), 10) || 0;
    var variantId = checked.getAttribute('data-variant-id');
    var qtySpan = box.querySelector('[data-lum-qty-value]');
    var qty = qtySpan ? parseInt(qtySpan.textContent, 10) || 1 : 1;

    var idInput = box.querySelector('input[name="id"]');
    if (idInput) idInput.value = variantId;

    var priceEl = box.querySelector('[data-lum-price]');
    if (priceEl) priceEl.textContent = formatMoney(price);
    var compareEl = box.querySelector('[data-lum-compare]');
    if (compareEl) {
      compareEl.textContent = compare > price ? formatMoney(compare) : '';
      compareEl.style.display = compare > price ? '' : 'none';
    }
    var saveEl = box.querySelector('[data-lum-save]');
    if (saveEl) {
      if (compare > price) {
        saveEl.textContent = 'SAVE ' + Math.round((1 - price / compare) * 100) + '%';
        saveEl.style.display = '';
      } else {
        saveEl.style.display = 'none';
      }
    }
    var atcPrice = box.querySelector('[data-lum-atc-price]');
    if (atcPrice) atcPrice.textContent = formatMoney(price * qty);
  }

  /* ---------- Rotating announcement bar ---------- */
  /* Fades between the announcement text and the extra rotating lines.
     Survives header re-renders: the element is re-queried each cycle. */
  var announceIdx = 0;
  setInterval(function () {
    var el = document.querySelector('[data-lum-announce]');
    if (!el) return;
    var msgs;
    try { msgs = JSON.parse(el.getAttribute('data-messages')); } catch (e) { return; }
    if (!msgs || msgs.length < 2) return;
    el.classList.add('is-fading');
    setTimeout(function () {
      var fresh = document.querySelector('[data-lum-announce]');
      if (!fresh) return;
      announceIdx = (announceIdx + 1) % msgs.length;
      fresh.innerHTML = msgs[announceIdx];
      fresh.classList.remove('is-fading');
    }, 380);
  }, 4200);

  /* ---------- Countdowns ---------- */
  /* [data-lum-countdown] with data-mode="midnight" | "fixed", data-end="ISO date"
     Children: [data-cd="h"], [data-cd="m"], [data-cd="s"] or [data-cd="hms"]  */

  /* Swap a countdown digit with a soft slide-in instead of a hard change */
  function setCdValue(el, v) {
    if (el.textContent === v) return;
    el.textContent = v;
    el.classList.remove('lum-cd-tick');
    void el.offsetWidth; /* restart the animation */
    el.classList.add('lum-cd-tick');
  }

  function tickCountdowns() {
    var nodes = document.querySelectorAll('[data-lum-countdown]');
    if (!nodes.length) return;
    var now = new Date();
    nodes.forEach(function (node) {
      var end;
      if (node.getAttribute('data-mode') === 'fixed' && node.getAttribute('data-end')) {
        end = new Date(node.getAttribute('data-end'));
        if (isNaN(end.getTime())) end = null;
      }
      if (!end) {
        end = new Date();
        end.setHours(23, 59, 59, 999); /* local midnight */
      }
      var s = Math.max(0, Math.floor((end - now) / 1000));
      var pad = function (n) { return String(n).padStart(2, '0'); };
      var h = pad(Math.floor(s / 3600)), m = pad(Math.floor((s % 3600) / 60)), sec = pad(s % 60);
      node.querySelectorAll('[data-cd]').forEach(function (el) {
        var kind = el.getAttribute('data-cd');
        if (kind === 'h') setCdValue(el, h);
        else if (kind === 'm') setCdValue(el, m);
        else if (kind === 's') setCdValue(el, sec);
        else el.textContent = h + ':' + m + ':' + sec;
      });
    });
  }
  setInterval(tickCountdowns, 1000);

  /* ---------- Seamless collection switching ---------- */
  /* Filter pills swap the catalog section in place via the Section
     Rendering API — no page reload. Falls back to navigation on error. */

  function swapCollection(url, push) {
    var main = document.getElementById('MainContent');
    if (!main) { window.location.href = url; return; }
    main.classList.add('lum-swap-out');
    fetch(url)
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var freshMain = doc.getElementById('MainContent');
        if (!freshMain) throw new Error('no main');
        main.innerHTML = freshMain.innerHTML;
        if (doc.title) document.title = doc.title;
        main.classList.remove('lum-swap-out');
        main.classList.add('lum-swap-in');
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { main.classList.remove('lum-swap-in'); });
        });
        updateAppliedCode();
        if (push) history.pushState({ lumCollection: true }, '', url);
      })
      .catch(function () { window.location.href = url; });
  }

  document.addEventListener('click', function (e) {
    var pill = e.target.closest('a.lum-pill');
    if (!pill) return;
    if (!pill.closest('[data-lum-collection]')) return;
    var url = pill.getAttribute('href');
    if (!url || url.indexOf('/collections/') !== 0) return;
    e.preventDefault();
    swapCollection(url, true);
  });

  window.addEventListener('popstate', function () {
    if (document.querySelector('[data-lum-collection]') && window.location.pathname.indexOf('/collections/') === 0) {
      swapCollection(window.location.pathname + window.location.search, false);
    }
  });

  /* ---------- Live social proof ---------- */
  /* [data-lum-social data-min data-max] with [data-lum-social-count] inside:
     a human-feeling random walk — one small step (±1–3) per minute, kept
     inside the range, never landing on round numbers (15, 20, 25). */

  var SOCIAL_SKIP = { 15: 1, 20: 1, 25: 1 };

  function driftSocial() {
    document.querySelectorAll('[data-lum-social]').forEach(function (node) {
      var el = node.querySelector('[data-lum-social-count]');
      if (!el) return;
      var min = parseInt(node.getAttribute('data-min'), 10) || 11;
      var max = parseInt(node.getAttribute('data-max'), 10) || 28;
      var cur = parseInt(el.textContent, 10) || min;
      var dir = Math.random() < 0.5 ? -1 : 1;
      var next = cur + dir * (1 + Math.floor(Math.random() * 3));
      if (next < min) { next = min + (min - next); dir = 1; }  /* reflect off the edges */
      if (next > max) { next = max - (next - max); dir = -1; }
      while (SOCIAL_SKIP[next]) next += dir;                    /* slide past 15 / 20 / 25 */
      if (next === cur) next = SOCIAL_SKIP[cur + dir] ? cur + 2 * dir : cur + dir;
      if (next < min || next > max || SOCIAL_SKIP[next]) next = cur;
      el.textContent = next;
    });
  }
  setInterval(driftSocial, 60000);

  /* ---------- Promo code (display only) ---------- */

  function knownCodes() {
    var list = (config.validCodes || []).slice();
    (config.oneItemCodes || []).forEach(function (c) { if (list.indexOf(c) === -1) list.push(c); });
    Object.keys(config.bundleCodes || {}).forEach(function (c) { if (list.indexOf(c) === -1) list.push(c); });
    return list;
  }

  function applyPromo(wrap) {
    if (!wrap) return;
    var input = wrap.querySelector('input');
    var entered = input ? input.value.trim().toUpperCase() : '';
    var okEl = wrap.parentElement.querySelector('[data-lum-promo-ok]');
    var errEl = wrap.parentElement.querySelector('[data-lum-promo-err]');
    function fail(msg) {
      if (errEl) { errEl.textContent = msg; errEl.style.display = ''; }
      if (okEl) okEl.style.display = 'none';
    }
    if (!entered) { fail('Please enter a code first.'); return; }
    if (knownCodes().indexOf(entered) === -1) { fail("That code isn't valid."); return; }
    /* Real code: prime Shopify's discount cookie, then re-render the cart
       so the server-applied discount (chips, totals) shows immediately. */
    fetch('/discount/' + encodeURIComponent(entered)).then(function () { refreshCartSections(); }).catch(function () {});
    if (okEl) okEl.style.display = '';
    if (errEl) errEl.style.display = 'none';
  }

  document.addEventListener('DOMContentLoaded', function () {
    tickCountdowns();
    updateAppliedCode();
    var box = document.querySelector('[data-lum-product]');
    if (box) updateBuybox(box);
  });
})();

/* Cart urgency countdown: re-queries the element every tick so it survives
   section re-renders; deadline persists in sessionStorage and restarts on expiry. */
(function () {
  function fmt(s) { var m = Math.floor(s / 60), x = s % 60; return (m < 10 ? '0' : '') + m + ':' + (x < 10 ? '0' : '') + x; }
  function tick() {
    var els = document.querySelectorAll('[data-lum-urgency]');
    if (!els.length) return;
    var mins = parseInt(els[0].getAttribute('data-lum-urgency'), 10) || 10;
    var end = 0;
    try { end = parseInt(sessionStorage.getItem('lumUrgencyEnd') || '0', 10); } catch (e) {}
    var now = Date.now();
    if (!end || end <= now || end - now > mins * 60000) {
      end = now + mins * 60000;
      try { sessionStorage.setItem('lumUrgencyEnd', String(end)); } catch (e) {}
    }
    var left = Math.max(0, Math.round((end - now) / 1000));
    els.forEach(function (el) {
      var t = el.querySelector('[data-lum-urgency-timer]');
      if (t) t.textContent = fmt(left);
    });
  }
  tick();
  setInterval(tick, 1000);
  document.addEventListener('DOMContentLoaded', tick);
})();

/* Product limited-stock counter: deterministic per product + ~47-min time window,
   so every visitor sees the same number, each product differs, and the value
   drifts on its own staggered schedule. */
(function () {
  function calc(el) {
    var pid = parseInt(el.getAttribute('data-lum-stock'), 10) || 1;
    var min = parseInt(el.getAttribute('data-stock-min'), 10) || 5;
    var max = parseInt(el.getAttribute('data-stock-max'), 10) || 10;
    if (max < min) { var t = min; min = max; max = t; }
    var win = Math.floor((Date.now() + (pid % 9973) * 60000) / 2820000);
    var seed = (pid % 100003) * 31 + win;
    seed = (seed * 9301 + 49297) % 233280;
    return min + (seed % (max - min + 1));
  }
  function tick() {
    document.querySelectorAll('[data-lum-stock]').forEach(function (el) {
      var c = el.querySelector('[data-lum-stock-count]');
      if (c) c.textContent = calc(el);
    });
  }
  tick();
  setInterval(tick, 60000);
  document.addEventListener('DOMContentLoaded', tick);
})();

/* Mini-review carousel rotation + social-proof number bolding */
(function () {
  var mrIdx = 0;
  setInterval(function () {
    var wrap = document.querySelector('[data-lum-minirev]');
    if (!wrap) return;
    var items = wrap.querySelectorAll('.lum-minirev__item');
    if (items.length < 2) return;
    var prev = items[mrIdx % items.length];
    mrIdx = (mrIdx + 1) % items.length;
    var next = items[mrIdx];
    items.forEach(function (el) { el.classList.remove('is-leaving'); });
    if (prev) { prev.classList.remove('is-on'); prev.classList.add('is-leaving'); }
    next.classList.add('is-on');
    setTimeout(function () { if (prev) prev.classList.remove('is-leaving'); }, 600);
  }, 4500);
  function boldNums() {
    document.querySelectorAll('.lum-pdp__social-line').forEach(function (line) {
      Array.prototype.slice.call(line.childNodes).forEach(function (n) {
        if (n.nodeType === 3 && /\d/.test(n.nodeValue)) {
          var span = document.createElement('span');
          span.innerHTML = n.nodeValue.replace(/(\d[\d,]*)/g, '<b>$1</b>');
          line.replaceChild(span, n);
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boldNums);
  else boldNums();
})();

/* Pre-checkout popup timer; the click logic lives in the main delegated
   handler so it can reach addToCart inside the theme closure. */
(function () {
  var pcLeft = 180;
  function fmt(s) { var m = Math.floor(s / 60), x = s % 60; return '0' + m + ':' + (x < 10 ? '0' : '') + x; }
  window.__lumPcReset = function (el) {
    pcLeft = 180;
    el = el || document.getElementById('LumPreCheckout');
    var t = el && el.querySelector('[data-lum-precheck-timer]');
    if (t) t.textContent = fmt(pcLeft);
  };
  setInterval(function () {
    ['LumPreCheckout', 'LumPreCheckoutDuo'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el || el.hidden) return;
      pcLeft = pcLeft > 0 ? pcLeft - 1 : 180;
      var t = el.querySelector('[data-lum-precheck-timer]');
      if (t) t.textContent = fmt(pcLeft);
    });
  }, 1000);
})();

/* Mobile product-page reorder: duo bundle right below Add to bag, then
   bonuses -> feature strip -> rotating reviews -> details ->
   comparison -> FAQ -> pay badges -> big reviews. The perks row stays in
   the buy column directly above the buy button (both breakpoints). Desktop
   DOM untouched; restores original positions when the viewport grows past 749px. */
(function () {
  if (!document.querySelector('.lum-pdp')) return;
  var mq = window.matchMedia('(max-width:749px)');
  var recs = null, moved = false;
  var slotSel = ['.lum-pdp__bonuses', '.lum-pdp__minirev',
                 '.lum-pdp__details', '.lum-paybadges'];

  function el(sel) { return document.querySelector(sel); }
  function secOf(sel) {
    var x = el(sel);
    return x ? x.closest('.shopify-section') : null;
  }

  function apply() {
    var buy = el('.lum-pdp__buy'); if (!buy) return;
    var mainSec = buy.closest('.shopify-section'); if (!mainSec) return;
    var duo = secOf('.lum-duo'), strip = secOf('.lum-strip'),
        comp = secOf('.lum-compare'), faq = secOf('.lum-acc'), rev = secOf('#reviews');
    var bon = el('.lum-pdp__bonuses'),
        mini = el('.lum-pdp__minirev'), det = el('.lum-pdp__details'),
        pay = el('.lum-paybadges');
    if (!recs) {
      recs = [duo, strip, comp, faq, rev, bon, mini, det, pay]
        .filter(Boolean)
        .sort(function (a, b) { return (a.compareDocumentPosition(b) & 4) ? -1 : 1; })
        .map(function (n) { return { n: n, p: n.parentNode, next: n.nextSibling }; });
    }
    slotSel.forEach(function (s) { var x = el(s); if (x) x.classList.add('lum-mob-slot', 'lum'); });
    var anchor = mainSec;
    [bon, duo, strip, mini, det, comp, faq, pay, rev].forEach(function (x) {
      if (x) { anchor.after(x); anchor = x; }
    });
    moved = true;
  }

  function restore() {
    if (!moved || !recs) return;
    for (var i = recs.length - 1; i >= 0; i--) {
      recs[i].p.insertBefore(recs[i].n, recs[i].next);
    }
    slotSel.forEach(function (s) { var x = el(s); if (x) x.classList.remove('lum-mob-slot', 'lum'); });
    moved = false;
  }

  function onChange() { if (mq.matches) { apply(); } else { restore(); } }
  onChange();
  if (mq.addEventListener) { mq.addEventListener('change', onChange); }
  else if (mq.addListener) { mq.addListener(onChange); }
})();

/* PDP gallery: arrows on the main image + fullscreen lightbox with arrows & thumb previews */
(function () {
  var gallery = document.querySelector('[data-lum-gallery]');
  if (!gallery) return;
  var media;
  try { media = JSON.parse(gallery.getAttribute('data-media') || '[]'); } catch (e) { media = []; }
  if (!media.length) return;
  var mainImg = gallery.querySelector('[data-lum-main-img]');
  var mainWrap = gallery.querySelector('.lum-pdp__main');
  var thumbs = gallery.querySelectorAll('.lum-pdp__thumb');
  var idx = 0;

  function chev(dir) {
    var d = dir < 0 ? 'm15 18-6-6 6-6' : 'm9 18 6-6-6-6';
    return '<svg class="lum-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="' + d + '"/></svg>';
  }

  // build lightbox (carries .lum so the inline icon styles apply)
  var lb = document.createElement('div');
  lb.className = 'lum-lightbox lum';
  lb.innerHTML =
    '<button class="lum-lightbox__close" aria-label="Close">&times;</button>' +
    '<div class="lum-lightbox__stage">' +
      '<button class="lum-lightbox__arr lum-lightbox__arr--prev" aria-label="Previous image">' + chev(-1) + '</button>' +
      '<img class="lum-lightbox__img" alt="">' +
      '<button class="lum-lightbox__arr lum-lightbox__arr--next" aria-label="Next image">' + chev(1) + '</button>' +
    '</div>' +
    '<div class="lum-lightbox__thumbs"></div>';
  document.body.appendChild(lb);
  var lbImg = lb.querySelector('.lum-lightbox__img');
  var lbThumbs = lb.querySelector('.lum-lightbox__thumbs');
  media.forEach(function (m, j) {
    var b = document.createElement('button');
    b.className = 'lum-lightbox__thumb';
    b.setAttribute('aria-label', 'View image ' + (j + 1));
    b.innerHTML = '<img src="' + m.thumb + '" alt="">';
    b.addEventListener('click', function () { show(j); });
    lbThumbs.appendChild(b);
  });
  var lbThumbEls = lbThumbs.querySelectorAll('.lum-lightbox__thumb');

  function show(i) {
    idx = (i % media.length + media.length) % media.length;
    var m = media[idx];
    if (mainImg) { mainImg.src = m.full; mainImg.removeAttribute('srcset'); if (m.alt) mainImg.alt = m.alt; }
    thumbs.forEach(function (b, j) { b.setAttribute('aria-current', j === idx ? 'true' : 'false'); });
    lbImg.src = m.full; lbImg.alt = m.alt || '';
    lbThumbEls.forEach(function (b, j) { b.classList.toggle('is-on', j === idx); });
  }

  var prev = gallery.querySelector('[data-lum-gallery-prev]');
  var next = gallery.querySelector('[data-lum-gallery-next]');
  if (prev) prev.addEventListener('click', function (e) { e.stopPropagation(); show(idx - 1); });
  if (next) next.addEventListener('click', function (e) { e.stopPropagation(); show(idx + 1); });
  thumbs.forEach(function (b, j) { b.addEventListener('click', function () { idx = j; show(j); }); });

  function open() { show(idx); lb.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function close() { lb.classList.remove('is-open'); document.body.style.overflow = ''; }
  if (mainImg) mainImg.addEventListener('click', open);
  var zoom = gallery.querySelector('[data-lum-gallery-open]');
  if (zoom) zoom.addEventListener('click', function (e) { e.stopPropagation(); open(); });
  lb.querySelector('.lum-lightbox__close').addEventListener('click', close);
  lb.querySelector('.lum-lightbox__arr--prev').addEventListener('click', function () { show(idx - 1); });
  lb.querySelector('.lum-lightbox__arr--next').addEventListener('click', function () { show(idx + 1); });
  lb.addEventListener('click', function (e) { if (e.target === lb || e.target.classList.contains('lum-lightbox__stage')) close(); });
  document.addEventListener('keydown', function (e) {
    if (!lb.classList.contains('is-open')) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') show(idx - 1);
    else if (e.key === 'ArrowRight') show(idx + 1);
  });
  function swipe(el) {
    var x0 = null;
    el.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    el.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) show(idx + (dx < 0 ? 1 : -1));
      x0 = null;
    }, { passive: true });
  }
  swipe(lb);
  if (mainWrap) swipe(mainWrap);
})();

/* Inline header product search — expands from the icon, searches product NAMES only */
(function () {
  var toggle = document.querySelector('[data-lum-search-toggle]');
  var panel = document.querySelector('[data-lum-search]');
  if (!toggle || !panel) return;
  var input = panel.querySelector('[data-lum-search-input]');
  var results = panel.querySelector('[data-lum-search-results]');
  var closeBtn = panel.querySelector('[data-lum-search-close]');
  var timer;

  function open() { panel.hidden = false; toggle.setAttribute('aria-expanded', 'true'); setTimeout(function () { input.focus(); }, 40); }
  function close() { panel.hidden = true; toggle.setAttribute('aria-expanded', 'false'); results.hidden = true; results.innerHTML = ''; }
  toggle.addEventListener('click', function () { panel.hidden ? open() : close(); });
  closeBtn.addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) close(); });
  document.addEventListener('click', function (e) {
    if (!panel.hidden && !panel.contains(e.target) && !toggle.contains(e.target)) close();
  });

  function priceStr(p) {
    if (p == null || p === '') return '';
    var s = String(p);
    if (s.indexOf('$') > -1) return s;
    var n = parseFloat(s);
    return isNaN(n) ? '' : '$' + n.toFixed(2);
  }
  function render(items) {
    results.hidden = false;
    if (!items.length) { results.innerHTML = '<div class="lum-hsearch__empty">No products match that.</div>'; return; }
    results.innerHTML = items.map(function (p) {
      var img = (p.featured_image && p.featured_image.url) ? p.featured_image.url : (p.image || '');
      var imgTag = img ? '<img src="' + img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=100" alt="">' : '<img alt="">';
      return '<a class="lum-hsearch__item" href="' + p.url + '">' + imgTag +
        '<span><span class="lum-hsearch__item-name">' + p.title + '</span>' +
        '<span class="lum-hsearch__item-price">' + priceStr(p.price) + '</span></span></a>';
    }).join('');
  }
  function run(q) {
    if (!q) { results.hidden = true; results.innerHTML = ''; return; }
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=8&resources[options][fields]=title';
    fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) { render((d.resources && d.resources.results && d.resources.results.products) || []); })
      .catch(function () {});
  }
  input.addEventListener('input', function () {
    clearTimeout(timer);
    var q = input.value.trim();
    timer = setTimeout(function () { run(q); }, 180);
  });
  // Never fall back to the full-page search: Enter goes to the first product match.
  var form = panel.querySelector('.lum-hsearch__bar');
  if (form) form.addEventListener('submit', function (e) {
    e.preventDefault();
    var first = results.querySelector('.lum-hsearch__item');
    if (first) window.location.href = first.getAttribute('href');
  });
})();
